// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__P05gF","disabled":"FileBtn_disabled__2-r_k","warn":"FileBtn_warn__2UqHn","fade":"FileBtn_fade__216ep"};